const sortMap = {
  manual: null, //this is how shopify sets 'featured' in the url
  'best-selling': [{ field: 'stats.buys', order: 'desc' }],
  'title-ascending': [{ field: 'name', order: 'asc' }],
  'title-descending': [{ field: 'name', order: 'desc' }],
  'price-ascending': [{ field: 'price', order: 'asc' }],
  'price-descending': [{ field: 'price', order: 'desc' }],
  'created-ascending': [{ field: 'datePublished', order: 'asc' }],
  'created-descending': [{ field: 'datePublished', order: 'desc' }]
}

//this is the mapping from the name in nosto facet manager to the url parameter we want to use
//the naming convention is similar to shopify's search and discovery app
const filterMap = {
  brand: 'filter.p.vendor',
  categories: 'filter.p.collection',
  'extra.filter-type': 'filter.p.m.type',
  'extra.filter-style': 'filter.p.m.style',
  'extra.filter-ip_rating': 'filter.p.m.ip-rating',
  'extra.filter-finish': 'filter.p.m.finish',
  'extra.filter-bulbs': 'filter.p.m.bulbs',
  'extra.filter-family': 'filter.p.m.family',
  'extra.filter-variant_finish': 'filter.v.variant-finish'
}

//set in shopify admin as a collection metafield
const DEFAULT_FINISH_FILTER =
  document
    .querySelector('#nosto-products')
    ?.getAttribute('data-default-finish-filter') || undefined

let PAGE_SIZE = 28 //this should match the paginate size in shopify liquid templates
let FROM = 0
let BLOCKS_TO_REPLACE_COUNT = 0
let CURRENT_PAGE_SIZE = 0
const productGridElement = document.querySelector('#nosto-products')
async function getNostoProducts({ page, loadMore = false, firstLoad = false }) {
  return new Promise((resolve, reject) => {
    const FEATURED_PRODUCT_BLOCK_INDICES = []
    //This is required to get the non-product feature blocks that are loaded in the liquid template, we take these and 'merge' them with
    //the Nosto products to ensure we have the same layout e.g. A full width review banner, the space filler element, and featured blocks
    //This logic also ensures we get the right number of products from Nosto for the layout
    let nonProductBlocks = {}
    if (firstLoad) {
      window.filters = { priceUpdated: false }
      if (window.limely?.collectionId) {
        nonProductBlocks = getNonProductGridBlocks(
          FEATURED_PRODUCT_BLOCK_INDICES
        )
        BLOCKS_TO_REPLACE_COUNT = Object.values(nonProductBlocks).filter(
          (block) => block.replacesProduct
        ).length
      } else {
        //when on search page, these indices don't change, as every featured block is a product block
        FEATURED_PRODUCT_BLOCK_INDICES.push(0, 13, 18, 27)
      }
    } else {
      window.filters = window.filters || { priceUpdated: false }
    }

    CURRENT_PAGE_SIZE = firstLoad
      ? PAGE_SIZE - BLOCKS_TO_REPLACE_COUNT
      : PAGE_SIZE

    whenAvailable(
      'nostojs',
      function () {
        nostojs(async (api) => {
          const filters = getFiltersFromUrl()
          const params = new URLSearchParams(window.location.search)
          const query = params.get('q')
          const sort_by = params.get('sort_by')

          try {
            const response = await api.search(
              {
                query: query,
                products: {
                  categoryId: window.limely?.collectionId || null,
                  facets: ['*'],
                  fields: [
                    'productId',
                    'url',
                    'availability',
                    'name',
                    'listPrice',
                    'price',
                    'imageUrl',
                    'skus',
                    'alternateImageUrls',
                    'customFields.key', //this returns any metafields as a customFields array
                    'customFields.value',
                    'skus.id',
                    'skus.name',
                    'skus.customFields.key',
                    'skus.customFields.value',
                    'skus.imageUrl',
                    'skus.price',
                    'skus.listPrice',
                    'skus.availability'
                  ],
                  filter: filters,
                  sort: sortMap[sort_by],
                  size: CURRENT_PAGE_SIZE,
                  from: FROM
                }
              },
              {
                redirect: true,
                track: window.limely?.collectionId ? 'category' : 'serp'
              }
            )

            FROM += CURRENT_PAGE_SIZE

            console.log('Nosto API - response.products: ', response.products)

            document.querySelector('#nosto-products-count').innerHTML =
              response.products.total

            checkIfMoreProductsToLoad(response.products)

            if (response.products.total === 0) {
              productGridElement.classList.add('no-results')
              productGridElement.innerHTML = '<h3>NO PRODUCTS FOUND</h3>'
              return
            } else {
              productGridElement.classList.remove('no-results')
            }

            const products = response.products.hits

            if (firstLoad) {
              Object.entries(nonProductBlocks).forEach(([key, value]) => {
                products.splice(key, 0, value)
              })
            }

            const FINISH_QUERY = new URLSearchParams(
              window.location.search
            ).getAll('filter.v.variant-finish')

            const productCardsHtml = products.map((product, index) =>
              firstLoad && product.productId === undefined
                ? product.html
                : productCardHtml(
                    product,
                    firstLoad && FEATURED_PRODUCT_BLOCK_INDICES.includes(index),
                    FINISH_QUERY
                  )
            )

            if (loadMore) {
              const parser = new DOMParser()
              productCardsHtml.forEach((productCard) => {
                const element = parser.parseFromString(productCard, 'text/html')
                  .body.firstChild
                productGridElement.insertAdjacentElement('beforeend', element)
              })
            } else {
              productGridElement.innerHTML = productCardsHtml.join(' ')
              productGridElement.classList.remove('skeleton')
            }

            buildFacets(response.products.facets)
            bindFilterDropdownEventHandlers()

            //this ensures the first item doesn't collapse when there are no adjacent product cards to prop it's height up
            if (response.products.hits.length === 1) {
              document
                .querySelector('a.product-card.grid-item-wide')
                ?.classList.remove('grid-item-wide', 'inset-footer')
            }
            updatePageTitle(response.products.total, query)
            resolve(response.products)
          } catch (error) {
            //fallback to shopify products if nosto fails
            productGridElement.classList.remove('skeleton')
            console.error('nosto search error:', error)
            reject(error)
          }
        })
      },
      function () {
        console.error(
          'Nosto took more than 5 seconds to load. Fallback to default products'
        )

        //show default products if Nosto takes longer than 5 seconds to load
        productGridElement.classList.remove('skeleton')
      }
    )
  })
}

const priceFormatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: window.Shopify?.currency?.active || 'GBP'
})

const formatPrice = (price) => priceFormatter.format(price)

const imagelyUrl = (src, width) => {
  const imagelyEndpoint = document
    .getElementById('nosto-products')
    ?.getAttribute('data-imagely-url')

  if (imagelyEndpoint) {
    let newUrl = src
      .replace('www.industville.co.uk/cdn/shop/', imagelyEndpoint)
      .replace('cdn.shopify.com/s/files/1/0250/0724/', imagelyEndpoint)

    if (newUrl.includes(imagelyEndpoint)) {
      newUrl += newUrl.includes('?') ? `&tr=w-${width}` : `?tr=w-${width}`
    }
    return newUrl
  } else {
    return src
  }
}

const getFieldValue = (product, key) =>
  JSON.parse(
    product.customFields?.find((field) => field.key === key)?.value || '[""]'
  )[0]

const setBadges = (product) => {
  function isProductReduced(product) {
    const variants = product.skus

    // Find the variant with the largest discount
    const itemWithLargestDiscount = variants.reduce((maxItem, item) =>
      (item.listPrice ?? 0) - item.price >
      (maxItem.listPrice ?? 0) - maxItem.price
        ? item
        : maxItem
    )

    const largestDiscount =
      (itemWithLargestDiscount.listPrice ?? 0) - itemWithLargestDiscount.price

    // Check if all variants have the same discount
    const firstDiscount = (variants[0].listPrice ?? 0) - variants[0].price
    const allSameDiscount = variants.every(
      (item) => (item.listPrice ?? 0) - item.price === firstDiscount
    )

    return itemWithLargestDiscount.listPrice > itemWithLargestDiscount.price
      ? `<div class="badge badge-sale">${
          allSameDiscount ? '' : 'UP TO'
        } £${largestDiscount} OFF</div>`
      : ''
  }

  function getProductBadges() {
    const productBadgeHandles = product.customFields?.find(
      (field) => field.key === 'custom-badges'
    )?.value

    if (productBadgeHandles !== undefined) {
      const badge_elements = JSON.parse(productBadgeHandles)
        .map((handle) => {
          const relevant_badge = window.limely.product_badges[handle]
          return `<div class="badge badge-${handle}">${relevant_badge.text}</div>`
        })
        .join('')

      return badge_elements
    } else {
      return ''
    }
  }

  return `<div class="product-badges mini">
      ${getProductBadges(product)}
      ${isProductReduced(product)}
    </div>`
}

const setReviewRating = (product) => {
  const getField = (key) =>
    product.customFields?.find((field) => field.key === key)?.value

  const reviewCount = getField('reviews-rating_count')
  const starCount =
    Math.round(JSON.parse(getField('reviews-rating') || '{}')?.value) || 0

  return reviewCount == 0
    ? ''
    : `
      <div class="product-review">
        <span class="count">(${reviewCount})</span>
        <span class="stars">${'★'.repeat(starCount)}</span>
      </div>
    `
}

const setPrice = (product) => {
  const variants = product.skus
  const { price, listPrice } = variants.reduce(
    (min, item) => (item.price < min.price ? item : min),
    variants[0]
  )

  return `
    <div class="product-price">
      ${variants.length > 1 ? '<span class="from">FROM</span>' : ''}
      ${
        listPrice > price
          ? `<s class="light">${formatPrice(listPrice)}</s>`
          : ''
      }
      <strong>${formatPrice(price)}</strong>
    </div>`
}

const setMainImage = (product, featuredProductCard) => {
  return product.imageUrl
    ? `<img 
        src="${imagelyUrl(product.imageUrl, featuredProductCard ? 800 : 400)}" 
        width="${featuredProductCard ? '800' : '400'}" 
        class="square product-image" 
        loading="lazy"
      />`
    : ''
}

const setHoverImage = (product, featuredProductCard) => {
  //get the first image with the suffix '.lifestyle' e.g. lampshade-lifestyle.jpeg
  //alternatively fallback to 2nd product image
  const hoverImage =
    product.alternateImageUrls?.find((img) => img.includes('-lifestyle.')) ||
    product.alternateImageUrls?.[0]

  return hoverImage
    ? `<img 
        src="${imagelyUrl(hoverImage, featuredProductCard ? 800 : 400)}" 
        width="400" 
        class="square hover-image" 
        loading="lazy"
      />`
    : ''
}

const setAvailability = (product) => {
  return product.availability !== 'InStock'
    ? '<div class="product-availability">OUT OF STOCK</div>'
    : ''
}

const getSpecificVariant = (product, finishQuery) => {
  //set order of filter priority, user set filters take precedence before default finish filter on collection
  const filter_order = [...finishQuery, DEFAULT_FINISH_FILTER].filter(Boolean)

  //if no finish filters are set, return the 'main product'
  if (filter_order.length === 0) return product

  //get first variant that matches the finish filter
  const variant = filter_order
    .map((color) =>
      product.skus.find((sku) =>
        sku.customFields.some(
          (field) =>
            field.key === 'filter-variant_finish' &&
            JSON.parse(field.value?.toLowerCase()).includes(color.toLowerCase())
        )
      )
    )
    .find(Boolean)

  if (variant) {
    //replace variant level properties to ensure product card represents relevant variant for applied filter
    return {
      ...product,
      availability: variant.availability,
      imageUrl: variant.imageUrl || product.imageUrl, //for some reason, sometimes the skus imageUrl is null
      listPrice: variant.listPrice,
      price: variant.price,
      url: variant.id ? `${product.url}?variant=${variant.id}` : product.url
    }
  } else {
    return product
  }
}

function productCardHtml(product, featuredProductCard, finishQuery) {
  const specificVariant = getSpecificVariant(product, finishQuery)

  return `
    <a 
      href="${specificVariant.url}" 
      class="product-card ${
        featuredProductCard ? 'grid-item-wide inset-footer' : ''
      }" 
      data-product-id="${product.productId}" 
      data-product-url="${specificVariant.url}"
    >
      <figure class="hover-zoom" title="${product.name}">
        <div class="top-row">
          ${setBadges(specificVariant)}
          <button 
            class="btn-wishlist" 
            data-product-url="${specificVariant.url}"
            title="Click to add/remove from your wishlist" 
          >
          </button>
        </div>
        <div class="bottom-row">
          <button class="btn btn-overlay btn-small btn-quickview">Quick View</button>
        </div>
        ${setHoverImage(specificVariant, featuredProductCard)}
        ${setMainImage(specificVariant, featuredProductCard)}
      </figure>
      <footer class="product-footer">
        <p class="product-card-title no-padding-top">
          ${
            getFieldValue(product, 'filter-family') ||
            getFieldValue(product, 'filter-type')
          }
        </p>
        ${setPrice(product)}
        ${setReviewRating(product)}
        <div class="product-title">
          ${wordLimitString(product.name, 20)}
        </div>
        ${setAvailability(specificVariant)}
      </footer>
    </a>
  `
}

function wordLimitString(string, wordLimit) {
  const words = string.split(' ')
  if (words.length <= wordLimit) return string
  return words.slice(0, wordLimit).join(' ') + '...'
}

function whenAvailable(name, callback, onTimeout) {
  let isResolved = false

  const timeoutId = setTimeout(() => {
    if (!isResolved) {
      isResolved = true
      onTimeout()
    }
  }, 5000)

  function checkAvailability() {
    if (isResolved) return
    if (window[name]) {
      isResolved = true
      clearTimeout(timeoutId)
      callback(window[name])
    } else {
      window.setTimeout(checkAvailability, 10)
    }
  }

  checkAvailability()
}

function checkIfMoreProductsToLoad(products) {
  const loadMoreButton = document.querySelector('a#nosto-load-more')
  if (products.from + products.size >= products.total) {
    loadMoreButton.hidden = true
  } else {
    loadMoreButton.hidden = false
  }
}

function buildFacets(facets) {
  const facetsHtml = facets.map((facet) => {
    const activeFiltersCount = (facet) => {
      const selectedCount = facet.data?.filter((item) => item.selected).length
      return selectedCount ? `<span>(${selectedCount})</span>` : ''
    }

    if (facet.type === 'terms') {
      return `
        <button type="button" class="filter-toggle" data-facet-id="${facet.id}">
          <div>
            <span>${facet.name}</span>
            ${activeFiltersCount(facet)}
          </div>
          <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path d="M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"/>
          </svg>
        </button>
        <div class="dropdown">
          <ul>
          ${facet.data
            .map((option, index) => {
              return `
              <li>
                <label>
                    <input
                      type="checkbox"
                      name="filter--${facet.field}--${index}"
                      value="${option.value}"
                      ${option.selected ? 'checked' : ''}
                      ${option.count === 0 ? 'disabled' : ''}
                    >
                    <div>
                      <span>${option.value}</span>
                      <span class="count">${option.count}</span>
                    </div> 
                </label>
              </li>
            `
            })
            .join(' ')}
          </ul>
        </div>
      `
    } else {
      const params = new URLSearchParams(window.location.search)
      const priceMinQuery = Number(params.get('filter.v.price.gte'))
      const priceMaxQuery = Number(params.get('filter.v.price.lte'))
      const priceMin = priceMinQuery || facet.min
      const priceMax = priceMaxQuery || facet.max

      const pricesSet = () => {
        if (
          priceMinQuery &&
          priceMaxQuery &&
          priceMin !== facet.min &&
          priceMax !== facet.max
        ) {
          return '<span>(2)</span>'
        } else if (
          (priceMinQuery && priceMin !== facet.min) ||
          (priceMaxQuery && priceMax !== facet.max)
        ) {
          return '<span>(1)</span>'
        } else {
          return ''
        }
      }

      return `
        <button type="button" class="filter-toggle" data-facet-id="${facet.id}">
          <div>
            <span>${facet.name}</span>
            ${pricesSet()}
          </div>
          <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path d="M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"/>
          </svg>
        </button>
        <div class="dropdown">
          <div class="price-range-slider">
            <input 
              type="range" 
              name="price-min" 
              id="minPrice" 
              min="${facet.min}" 
              max="${facet.max}" 
              step="1" 
              value="${priceMin}"
            >
            <input 
              type="range" 
              name="price-max" 
              id="maxPrice" 
              min="${facet.min}" 
              max="${facet.max}" 
              step="1" 
              value="${priceMax}"
            >
            <div class="price-range-labels">
              <span id="minPriceValue">${priceMin}</span> 
              <span id="maxPriceValue">${priceMax}</span>
            </div>
          </div>
        </div>
      `
    }
  })

  document.querySelector('main#nosto-facets').innerHTML = facetsHtml.join(' ')

  //update min price label
  document
    .querySelector('input[type="range"]#minPrice')
    ?.addEventListener('change', function (event) {
      window.filters.priceUpdated = true
      document.querySelector('#minPriceValue').innerHTML = event.target.value
    })

  //update max price label
  document
    .querySelector('input[type="range"]#maxPrice')
    ?.addEventListener('change', function (event) {
      window.filters.priceUpdated = true
      document.querySelector('#maxPriceValue').innerHTML = event.target.value
    })
}

function bindFilterDropdownEventHandlers() {
  document
    .querySelectorAll('main#nosto-facets button.filter-toggle')
    .forEach((toggle) => {
      toggle.addEventListener('click', () => {
        toggle.classList.toggle('active')
        const panel = toggle.nextElementSibling
        panel.style.maxHeight = panel.style.maxHeight
          ? null
          : `${panel.scrollHeight}px`
      })
    })
}

//this gets any non-product featured items from the html before nosto replaces the grid
//these items are rendered initially using liquid, and are populated by the user in the shopify admin
//this method means we don't have to template these in both liquid, and js
function getNonProductGridBlocks(featured_block_indices) {
  const nonProductBlocks = {}

  document.querySelectorAll('#nosto-products > *').forEach((item, index) => {
    if (!item.classList.contains('product-card')) {
      const parent = item.parentNode
      const index = Array.prototype.indexOf.call(parent.children, item)
      nonProductBlocks[index] = {
        html: item.outerHTML,
        replacesProduct: item.classList.contains('product-grid-featured-block')
      }
    }

    if (item.classList.contains('grid-item-wide')) {
      featured_block_indices.push(index)
    }
  })

  return nonProductBlocks
}

if (document.querySelector('form#nosto-filters')) {
  const filterForm = document.querySelector('form#nosto-filters')
  filterForm.addEventListener('submit', filterFormUpdated)
}

async function filterFormUpdated(event) {
  event.preventDefault()
  const formValues = Object.fromEntries(new FormData(this))
  formDataToUrlParams(formValues)

  FROM = 0 //reset back to zero when changing filter criteria
  await getNostoProducts({
    page: 1
  })
}

//this id is set on the product grid of category and search results pages when Nosto merchandising is enabled in the global settings
if (document.querySelector('#nosto-products')) {
  const params = new URLSearchParams(window.location.search)
  const sort_by = params.get('sort_by')

  const relevantSortCheckbox = document.querySelector(
    `input[name="sort-nosto"][value="${sort_by}"]`
  )
  if (relevantSortCheckbox) {
    relevantSortCheckbox.checked = true
  }

  initNostoIntegration()
}

async function initNostoIntegration() {
  const url = new URL(window.location.href)
  let page = Number(url.searchParams.get('p') || 1)

  //INITIAL LOAD OF PRODUCTS
  await getNostoProducts({
    page: 1,
    firstLoad: page === 1
  })

  document
    .querySelector('a#nosto-load-more')
    .addEventListener('click', async function (event) {
      event.preventDefault()
      page++
      await getNostoProducts({
        page: page,
        loadMore: true
      })

      //set page parameter in url
      const url = new URL(window.location.href)
      url.searchParams.set('p', page)
      window.history.replaceState({}, '', url)
      //set href on load more button to the next page url
      url.searchParams.set('p', page + 1)
      this.href = url
    })

  const pageInUrl = Number(url.searchParams.get('p'))
  const pages = [...Array(pageInUrl)].map((_, index) => index + 1)
  for (const page of pages) {
    if (page > 1) {
      await getNostoProducts({
        page: page,
        loadMore: true
      })
    }
  }

  sortDropdownToggleEventListener()
}

function getFiltersFromUrl() {
  const params = new URLSearchParams(window.location.search)

  const getDecodedValues = (key) => {
    const values = params.getAll(key)
    return values.length
      ? values.map((value) => decodeURIComponent(value))
      : null
  }

  const filters = []

  for (const [key, value] of Object.entries(filterMap)) {
    const entry = getDecodedValues(value)
    if (entry) {
      filters.push({ field: key, value: entry })
    }
  }

  const minPrice = params.get('filter.v.price.gte')
  const maxPrice = params.get('filter.v.price.lte')

  if (minPrice && maxPrice) {
    filters.push({ field: 'price', range: [{ gte: minPrice, lte: maxPrice }] })
  }

  return filters
}

function formDataToUrlParams(formData) {
  function getMappedKey(key) {
    if (key === 'sort-nosto') return 'sort_by'
    if (window.filters.priceUpdated === true && key === 'price-min')
      return 'filter.v.price.gte'
    if (window.filters.priceUpdated === true && key === 'price-max')
      return 'filter.v.price.lte'

    for (const [mapKey, mapValue] of Object.entries(filterMap)) {
      const regex = new RegExp(`^filter--${mapKey}--\\d+$`)
      if (regex.test(key)) return mapValue
    }
    return null // Return null if no mapping is found
  }

  const queryParams = []

  for (const [key, value] of Object.entries(formData)) {
    const mappedKey = getMappedKey(key)
    if (mappedKey) {
      queryParams.push(
        `${encodeURIComponent(mappedKey)}=${encodeURIComponent(value)}`
      )
    }
  }

  //ensure these query params persist
  const url = new URL(window.location.href)
  const paramsToPersist = ['q', 'view']
  paramsToPersist.forEach((param) => {
    const value = url.searchParams.get(param)
    if (value) {
      queryParams.unshift(`${param}=${value}`)
    }
  })

  const queryString = queryParams.join('&')
  const newURL = `${window.location.origin}${window.location.pathname}?${queryString}`
  window.history.replaceState(null, '', newURL)
}

function sortDropdownToggleEventListener() {
  document
    .querySelector('button#nosto-sort-toggle')
    ?.addEventListener('click', function () {
      this.classList.toggle('active')
      const panel = this.nextElementSibling
      panel.style.maxHeight = panel.style.maxHeight
        ? null
        : `${panel.scrollHeight}px`
    })
}

const updatePageTitle = (total, query) => {
  //if on the search results page
  if (!window.limely?.collectionId) {
    document.querySelector(
      'head title'
    ).text = `Search: ${total} results found for "${query}" - Industville`
  }
}
